module.exports = __webpack_public_path__ + "img/tsuki.b3c5b4db.jpg";